export default __webpack_public_path__ + "static/media/photo--lg--77.3dafb4d6.jpg";